import { render, staticRenderFns } from "./SharingInput.vue?vue&type=template&id=c27868c6"
import script from "./SharingInput.vue?vue&type=script&lang=js"
export * from "./SharingInput.vue?vue&type=script&lang=js"
import style0 from "./SharingInput.vue?vue&type=style&index=0&id=c27868c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports